<template>
  <div class="warp ">
    <img class="top_bg" src="@/assets/img/common/bg2.png" alt="" />
    <div class="layout_con page_w">
      <myHeader></myHeader>
      <!-- 面包屑 -->
      <div class="crumbs_warp">
        <div class="crumbs_box">
          <div class="flex">
            <i class="crumbs_icon">
              <img src="@/assets/img/common/crumbs_icon.png" alt="" />
            </i>
            <div class="crumbs">
              <router-link class="item" to="/">首页 &gt;</router-link>
              <router-link class="item" to="/resourceList"
                >资源列表
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- content -->
      <div class="retrieval_warp">
        <div class="search_box">
          <input
            class="search_keyword"
            type="text"
            placeholder="请输入方志书名"
            v-model="keyword"
            @keyup.enter="toSearch"
          />
          <div class="search_btn flex" @click="toSearch">
            <button>
              <img src="@/assets/img/common/fangdajing.png" alt="" />
            </button>
          </div>
        </div>
        <div class="retrieval_nav">
          <div
            class="item"
            :class="currentTab === index ? 'active' : ''"
            v-for="(item, index) in retrievalTab"
            :key="index"
            @click="changeTabs(index, item.label, item.params)"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
      <div v-if="bookList.length > 0" class="main_warp">
        <div class="top_label">
          <div class="top_title">{{ tipsName }}列表</div>
          <div class="change_btns">
            <div
              :class="switchMode === true ? 'active' : ''"
              @click="switchMode = true"
            >
              <i>
                <img src="@/assets/img/resourceList/tupian.png" alt="" />
                <img src="@/assets/img/resourceList/tupian_h.png" alt="" />
              </i>
              <span>图片模式</span>
            </div>
            <div
              :class="switchMode === false ? 'active' : ''"
              @click="switchMode = false"
            >
              <i>
                <img src="@/assets/img/resourceList/zhaiyao.png" alt="" />
                <img src="@/assets/img/resourceList/zhaiyao_h.png" alt="" />
              </i>
              <span>摘要模式</span>
            </div>
          </div>
        </div>
        <div class="main">
          <transition
            name="animate__animated animate__bounce"
            enter-active-class="animate__fadeIn"
            leave-active-class="animate__fadeOut"
            mode="out-in"
          >
            <div class="empty_con" v-if="switchMode" :key="1">
              <ul class="picture_list">
                <li
                  v-for="(item, index) in bookList"
                  :key="index"
                  :title="item.name"
                >
                  <div @click="jump(item.category, item.id)" class="item">
                    <div class="item_bg_box flex">
                      <div class="item_bg">
                        <div class="item_img_box">
                          <img
                            class="item_img"
                            :src="encodeURI(item.image)"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="item_info flex">
                      <p>{{ item.name }}</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="empty_con" v-else :key="2">
              <ul class="book_list">
                <li class="item" v-for="(item, index) in bookList" :key="index">
                  <div class="item_img_box">
                    <img class="item_img" :src="encodeURI(item.image)" alt="" />
                  </div>
                  <div class="item_info">
                    <div class="item_title">
                      {{ item.name }}
                    </div>
                    <p>
                      <span>主题词：</span>
                      <span>{{ item.keyword }}</span>
                    </p>
                    <p>
                      <span>中图分类号：</span>
                      <span>{{ item.classify }}</span>
                    </p>

                    <p class="jianjie">
                      <span>简介：</span>
                      <span>{{ item.content }} </span>
                    </p>
                    <div
                      class="to_details flex"
                      @click="jump(item.category, item.id)"
                    >
                      查看详情
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </transition>
        </div>
        <!-- 分页 -->
        <el-pagination
          background
          :hide-on-single-page="true"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <div v-else class="no_data">
        <img src="@/assets/img/common/no_data.svg" alt="" />
        <p>
          没有找到相关的内容
        </p>
      </div>

      <!-- content end -->
    </div>
    <!-- 侧边导航 -->
    <sideTips></sideTips>
    <myFooter></myFooter>
  </div>
</template>

<script>
import myFooter from '@/components/myFotter/index.vue'
import myHeader from '@/components/myHeader/index.vue'
import sideTips from '@/components/sideTips/index.vue'
export default {
  metaInfo: {
    title: '宝鸡市扶风县数字方志库-资源列表'
  },
  components: {
    myFooter,
    myHeader,
    sideTips
  },
  data() {
    return {
      keyword: '', //搜索关键字
      retrievalTab: [
        // {
        //   label: '年鉴',
        //   subscript: 0,
        //   params: 'yearbooks'
        // },
        {
          label: '区县志',
          subscript: 1,
          params: 'countyAnnals'
        },
        {
          label: '行业志',
          subscript: 2,
          params: 'industryAnnals'
        }
        // {
        //   label: '地情资料',
        //   subscript: 3,
        //   params: 'geologicalInformation'
        // }
      ],
      currentRetrieval: '', //当先tab选中的那个
      tipsName: '年鉴',
      bookList: [], // 方志列表
      currentTab: 0, //当前分类选择
      switchMode: true, //切换显示模式
      pageSize: 20,
      currentPage: 1,
      total: null
    }
  },
  mounted() {
    this.currentRetrieval = this.retrievalTab[0].params
    this.fromSearch()
  },
  methods: {
    // 传递过来参数的搜索
    fromSearch() {
      this.keyword = this.$route.query.keyword
      this.getBookData(this.retrievalTab[0].params)
    },
    // 搜索
    toSearch() {
      this.currentPage = 1
      this.getBookData(this.currentRetrieval)
      // 改变路由参数
      this.$router.push({ query: { keyword: this.keyword } })
    },
    // 选择tabs
    changeTabs(i, label, params) {
      this.currentTab = i
      this.tipsName = label
      this.currentRetrieval = params
      this.currentPage = 1
      this.getBookData(params)
    },
    // 获取列表
    async getBookData(params) {
      const { content: bookList, totalElements: total } = await this.$http.get(
        `/api/home/index/${params}`,
        {
          params: {
            enabled: true,
            sort: 'sort,desc',
            page: this.currentPage - 1,
            size: this.pageSize,
            name: this.keyword
          }
        }
      )
      this.total = total
      this.bookList = bookList
    },
    // 分页
    handleCurrentChange(index) {
      this.currentPage = index
      this.getBookData(this.currentRetrieval)
    },
    // 跳转详情
    jump(flag, id) {
      let category = Number(flag)
      if (category === 1) {
        this.$router.push(`resourceList/yearBooks?id=${id}`)
      } else if (category === 2) {
        this.$router.push(`resourceList/countyAnnals?id=${id}`)
      } else if (category === 3) {
        this.$router.push(`resourceList/industryAnnals?id=${id}`)
      } else if (category === 4) {
        this.$router.push(`resourceList/geological?id=${id}`)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.retrieval_warp {
  width: 100%;
  height: 300px;
  background: url('../../assets/img/resourceList/retrieval_bg.png') no-repeat
    center;
  background-size: 100% 100%;
  overflow: hidden;
}
.search_box {
  width: 80%;
  height: 46px;
  display: flex;
  border-radius: 4px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 70px;
  .search_keyword {
    flex: 1;
    border: 0;
    background: #fff;
    padding: 0 10px;
    color: #9a856d;
    &::-webkit-input-placeholder {
      color: #9a856d;
      font-size: 14px;
      letter-spacing: 2px;
    }
  }
  .search_btn {
    width: 90px;
    background: @theme;
    cursor: pointer;
    button {
      border: 0;
      background: transparent;
      cursor: pointer;
    }
  }
}
.retrieval_nav {
  width: 90%;
  margin: 0 auto;
  display: flex;
  // justify-content: space-around;
  justify-content: center;
  margin-top: 70px;
  .item {
    width: 160px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    transition: all 0.2s;
    background: url('../../assets/img/resourceList/tab.png') no-repeat center;
    margin-right: 70px;
    &:hover {
      background: url('../../assets/img/resourceList/tab_h.png') no-repeat
        center;
      color: #fff;
    }
  }
  .active {
    background: url('../../assets/img/resourceList/tab_h.png') no-repeat center;
    color: #fff;
  }
}
.main_warp {
  margin-top: 60px;
  .empty_con {
    animation-duration: 0.4s;
  }
  .top_label {
    height: 40px;
    padding: 0 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #e4e8ed;
    box-shadow: 0 1px 6px rgb(0 0 0 / 20%);
    margin-bottom: 30px;
  }
  .change_btns {
    display: flex;
    align-items: center;
    div {
      display: flex;
      align-items: center;
      margin-right: 20px;
      cursor: pointer;
      font-size: 14px;
      i {
        margin-right: 4px;
        img {
          &:nth-child(2) {
            display: none;
          }
        }
      }
    }
    .active {
      color: @theme;
      i {
        img {
          &:nth-child(1) {
            display: none;
          }
          &:nth-child(2) {
            display: block;
          }
        }
      }
    }
  }
  // 图片模式
  .picture_list {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 20%;
      margin-bottom: 30px;
      &:hover {
        .item_img_box {
          transform: rotateY(20deg);
        }
        .item_img {
          transform: rotateY(20deg);
        }
      }
    }
    .item {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      .item_bg_box {
        width: 160px;
        height: 230px;
        background: url('../../assets/img/index/book_bg.jpg') no-repeat center;
      }
      .item_bg {
        width: 160px;
        height: 230px;
        background-color: #656566;
        border-radius: 5px;
      }
      .item_img_box {
        width: 100%;
        height: 100%;
        transition: all 0.6s;
        background-color: #fff;
        transform-origin: 0 100% 0;

        .item_img {
          width: 100%;
          height: 100%;
          transform-origin: 0 100% 0;
          transition: all 0.6s;
          border-radius: 5px;
        }
      }
    }
    .item_info {
      width: 160px;
      margin-top: 10px;
      flex-direction: column;
      p {
        width: 100%;
        margin: 6px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        color: #333;
      }
    }
  }
  // 摘要模式
  .book_list {
    .item {
      display: flex;
      padding: 30px;
      transition: all 0.2s ease-out;
      &:hover {
        background: #e4e8ed;
      }
    }
    .item_img_box {
      width: 160px;
      height: 230px;
      margin-right: 40px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .item_info {
      flex: 1;
      position: relative;
      .item_title {
        font-size: 24px;
        color: #4e2f0d;
        margin-bottom: 8px;
      }
      p {
        font-size: 14px;
        line-height: 32px;
        span {
          &:nth-child(1) {
            color: #807568;
            float: left;
          }
          &:nth-child(2) {
            color: #544a40;
          }
        }
      }
      .jianjie {
        span {
          &:nth-child(1) {
            float: left;
          }
          &:nth-child(2) {
            height: 64px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
      .to_details {
        width: 100px;
        height: 34px;
        border: 1px solid #999999;
        border-radius: 4px;
        font-size: 14px;
        color: #333;
        position: absolute;
        bottom: 0;
        transition: all 0.2s ease-out;
        cursor: pointer;
        &:hover {
          background: @theme;
          color: #fff;
          border-color: @theme;
        }
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .picture_list {
    li {
      width: 25% !important;
    }
  }
}
</style>
